//#region Imports 
import { useState, useEffect } from "react";
import sharedDatas from "../../../businessLogic/sharedDatas";
import { useNavigate } from "react-router-dom";

//oneFront SDK
import {
  useSnackbar,
  useQuery,
  useMutation,
  useTranslation,
} from "@1f/react-sdk";

import VaporPage from "@vapor/react-custom/VaporPage";

//Vapor Components
import Grid from "@vapor/react-material/Grid";
import Stack from "@vapor/react-material/Stack";
import Button from "@vapor/react-material/Button";
import IconButton from "@vapor/react-material/IconButton";
import FormControl from "@vapor/react-material/FormControl";
import InputLabel from "@vapor/react-material/InputLabel";
import Select from "@vapor/react-material/Select";
import MenuItem from "@vapor/react-material/MenuItem";
import Divider from "@vapor/react-material/Divider";

import {
  DataGridPro,
  GridToolbar,
  itIT,
} from "@mui/x-data-grid-pro";

//Icons
import {
  AddOutlined as AddIcon,
  DeleteOutlineOutlined as DeleteIcon,
  ModeEditOutlineOutlined as EditIcon,
  ArrowForward as DetailIcon,
} from "@mui/icons-material";

//Custom components
import { Loading } from "../../../components/Loading";
import { NotAuth } from "../../../components/NotAuth";
import { NoData } from "../../../components/NoData";
import { TabellaBaseForm } from "../../../components/tabellaBase/TabellaBaseForm";
import { ModalDelete } from "../../../components/ModalDelete";

//Constants, Api and Data Models
import {
  pathImpTabBaseHome
} from "../../../businessLogic/constants/path";
import {
  bsaSettingsTabellaBase
} from "../../../businessLogic/constants/securityAreas";

import { getTabelleBase } from "../../../businessLogic/helpers/baseTableHelpers";
import {
  userPermissionModel,
  baseMezzoPagamentoModel,
  baseOrigineFondiModel,
  baseTipoDocumentoModel,
} from "../../../businessLogic/models";
import { LogApi } from "../../../businessLogic/api/logApi";

import {
  query_base_mezzo_pagamento,
  query_base_origine_fondi,
  query_base_tipo_documento,
  query_base_tipo_documento_system,
} from "../../../businessLogic/query/baseTablesQueries";

import {
  query_anagrafiche_byTenant
} from "../../../businessLogic/query/anagraficaQueries";

import {
  mutation_add_audit
} from "../../../businessLogic/mutations/auditMutations";
import {
  mutation_add_lastActivity_byUserId,
  mutation_delete_lastActivity
} from "../../../businessLogic/mutations/lastActivityMutations";
import {
  mutation_delete_base_mezzo_pagamento,
  mutation_delete_base_origine_fondi,
  mutation_delete_base_tipo_documento
} from "../../../businessLogic/mutations/baseTablesMutations";

//Other components
import { v4 as uuidv4 } from "uuid";
//#endregion

export const TabellaBaseHome = ({ basePath }) => {
  const tenantId = sharedDatas.getPropertyByName("tenantId");
  const aziendaId = sharedDatas.getPropertyByName("aziendaId");
  const loggedUserId = sharedDatas.getPropertyByName("userId");
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const logApi = LogApi();

  //#region Query
  const apiBaseMezzoPagamento = useQuery(
    query_base_mezzo_pagamento,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiBaseOrigineFondi = useQuery(
    query_base_origine_fondi,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiBaseTipoDocumento = useQuery(
    query_base_tipo_documento,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiBaseAllTipoDocumento = useQuery(
    query_base_tipo_documento_system,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiAnagraficheByTenant = useQuery(
    query_anagrafiche_byTenant,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  //#endregion

  //#region Mutation
  const apiAddAudit = useMutation(mutation_add_audit, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiAddLastActivity = useMutation(mutation_add_lastActivity_byUserId, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiDeleteLastActivity = useMutation(mutation_delete_lastActivity, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiDeleteBaseMezzoPagamento = useMutation(
    mutation_delete_base_mezzo_pagamento,
    { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiDeleteBaseOrigineFondi = useMutation(
    mutation_delete_base_origine_fondi,
    { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiDeleteBaseTipoDocumento = useMutation(
    mutation_delete_base_tipo_documento,
    { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  //#endregion

  //#region Usestates
  const [backDropOpen, setBackDropOpen] = useState(true); //Loader utilizzato durante il caricamento
  const [isDataLoaded, setIsDataLoaded] = useState(false); //Indica lo stato di caricamento del result Api
  const [isTenantEnabled, setIsTenantEnabled] = useState(false);
  const [userPermissions, setUserPermissions] = useState(
    new userPermissionModel(
      0,
      aziendaId,
      bsaSettingsTabellaBase,
      false,
      false,
      false,
      false
    )
  );
  const [tabelleList, setTabelleList] = useState([]); //Contiene il result completo
  const [showAddModal, setShowAddModal] = useState(false); //Modal per l'aggiunta/modifica di un record
  const [showDeleteModal, setShowDeleteModal] = useState(false); //Modal per la conferma di eliminazione di un record
  const [idToPerform, setIdToPerform] = useState(0); //Contiene l'id del record da eliminare
  const [allBaseTipiDocumento, setAllBaseTipiDocumento] = useState([]);
  //#endregion

  useEffect(() => {
    loadDatas();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoaded]);
  


  async function loadDatas() {
    try {
      if (
        sharedDatas.getPropertyByName("tenantId") === "" ||
        sharedDatas.getPropertyByName("tenantModel") === null ||
        sharedDatas.getPropertyByName("aziendaId") === 0 ||
        sharedDatas.getPropertyByName("aziendaModelList") === null ||
        sharedDatas.getPropertyByName("userId") === "" ||
        sharedDatas.getPropertyByName("userModel") === null
      ) {
        navigate("/");
      } else {
        setBackDropOpen(true);

        if (!isDataLoaded) {
          //Last Activity
          await apiDeleteLastActivity.fetch({
            tenantId: tenantId,
            aziendaId: aziendaId,
            userId: loggedUserId,
          });
          await apiAddLastActivity.fetch({
            tenantId: tenantId,
            aziendaId: aziendaId,
            path: pathImpTabBaseHome,
            entityId: "",
            entityName: "",
          });

          /**************************************/
          //Carico le informazioni relative al Tenant
          const tenantInfos = sharedDatas.getPropertyByName("tenantModel");
          const isEnabled =
            !tenantInfos.isReadOnly &&
            !tenantInfos.isDisabled &&
            !tenantInfos.isDeleted;
          setIsTenantEnabled(isEnabled);

          /**************************************/
          //Carico i permessi relativi all'utente
          setUserPermissions(
            sharedDatas
              .getPropertyByName("userPermissions")
              .filter((x) => x.area === bsaSettingsTabellaBase)[0]
          );

          /**************************************/
          //Carico le Tabelle di base
          setTabelleList(getTabelleBase());
        }
      }
    } catch (e) {
      logApi.AddLog(e.message,e.stack,"loadDatas", "TabellaBaseHome")      
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    } finally {
      setBackDropOpen(false);
      setIsDataLoaded(true);
    }
  }

  //#region Controls
  const [tabella, setTabella] = useState(""); //Contiene il value della tabella selezionata
  const [tabellaItems, setTabellaItems] = useState([]); //Contiene i records della tabella selezionata
  const [tabellaColumns, setTabellaColumns] = useState([]); //Contiene le rows della tabella selezionata
  const [tabellaRows, setTabellaRows] = useState([]); //Contiene le rows della tabella selezionata

  const handleDdlTabellaChange = async (event) => {
    try {
      setBackDropOpen(true);

      const selectedValue = event.target.value;
      setTabella(selectedValue);
      setTabellaItems([]);
      setTabellaColumns([]);
      setTabellaRows([]);
      setShowAddModal(false);

      if (selectedValue !== "") {
        //In base alla tabella selezionata recupero i records
        await loadTabellaDatas(selectedValue);
      } else {
        setTabella("");
        setTabellaItems([]);
        setTabellaRows([]);
        setTabellaColumns([]);
      }
    } catch (e) {
      logApi.AddLog(e.message,e.stack,"handleDdlTabellaChange", "TabellaBaseHome")      
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    } finally {
      setBackDropOpen(false);
    }
  };
  const loadTabellaDatas = async (tableName) => {
    try {
      if (tableName === "base_mezzo_pagamento") {
        setTabellaColumns([
          { field: "id", headerName: "Id", flex: 0.2, type: "number" },
          {
            field: "value",
            headerName: t("impostazioni.tabellaBase.form.value"),
            flex: 1,
            editable: false,
          },
          {
            field: "actions",
            headerName: "",
            flex: 0.2,
            filterable: false,
            renderCell: (params) => renderDetailsButton(params.row),
          },
        ]);

        const tbResponse = await apiBaseMezzoPagamento.fetch({
          tenantId: tenantId,
        });
        const arrItems = [];
        for (
          let i = 0;
          i < tbResponse.data.data.base_mezzo_pagamento.length;
          i++
        ) {
          const item = tbResponse.data.data.base_mezzo_pagamento[i];
          const itemModel = new baseMezzoPagamentoModel(
            item.Id,
            item.Key,
            item.Value,
            item.Order,
            item.IsSystem
          );
          arrItems.push(itemModel);
        }
        setTabellaItems(arrItems);
        setTabellaRows(arrItems);
      } else if (tableName === "base_origine_fondi") {
        setTabellaColumns([
          { field: "id", headerName: "Id", flex: 0.2, type: "number" },
          {
            field: "value",
            headerName: t("impostazioni.tabellaBase.form.value"),
            flex: 1,
            editable: false,
          },
          {
            field: "actions",
            headerName: "",
            flex: 0.2,
            filterable: false,
            renderCell: (params) => renderDetailsButton(params.row),
          },
        ]);

        const tbResponse = await apiBaseOrigineFondi.fetch({
          tenantId: tenantId,
        });
        const arrItems = [];
        for (
          let i = 0;
          i < tbResponse.data.data.base_origine_fondi.length;
          i++
        ) {
          const item = tbResponse.data.data.base_origine_fondi[i];
          const itemModel = new baseOrigineFondiModel(
            item.Id,
            item.Key,
            item.Value,
            item.Order,
            item.IsSystem
          );
          arrItems.push(itemModel);
        }
        setTabellaItems(arrItems);
        setTabellaRows(arrItems);
      } else if (tableName === "base_tipo_documento") {
        setTabellaColumns([
          { field: "id", headerName: "Id", flex: 0.2, type: "number" },
          {
            field: "value",
            headerName: t("impostazioni.tabellaBase.form.value"),
            flex: 1,
            editable: false,
          },
          {
            field: "actions",
            headerName: "",
            flex: 0.2,
            filterable: false,
            renderCell: (params) => renderDetailsButton(params.row),
          },
        ]);

        const tbResponse = await apiBaseTipoDocumento.fetch({
          tenantId: tenantId,
        });
        const arrItems = [];
        for (
          let i = 0;
          i < tbResponse.data.data.base_tipo_documento.length;
          i++
        ) {
          const item = tbResponse.data.data.base_tipo_documento[i];
          const itemModel = new baseTipoDocumentoModel(
            item.Id,
            item.Key,
            item.Value,
            item.Order,
            item.IsSystem
          );
          arrItems.push(itemModel);
        }
        setTabellaItems(arrItems);
        setTabellaRows(arrItems);

        const allDocumentType = await apiBaseAllTipoDocumento.fetch();
        setAllBaseTipiDocumento(allDocumentType.data.data.base_tipo_documento);
      }
    } catch (e) {
      logApi.AddLog(e.message,e.stack,"loadTabellaDatas", "TabellaBaseHome")      
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  //#endregion

  //#region Grid Button Detail
  const renderDetailsButton = (item) => {
    return (
      <Stack direction='row' spacing={0}>
        {isTenantEnabled && userPermissions.canDelete && !item.isSystem ? (
          <IconButton
            color='error'
            onClick={(e) => handleGridBtnDeleteClick(e, item)}
          >
            <DeleteIcon />
          </IconButton>
        ) : null}
        {isTenantEnabled && userPermissions.canUpdate && !item.isSystem ? (
          <IconButton
            color='primary'
            onClick={(e) => handleGridBtnEditClick(e, item)}
          >
            <EditIcon />
          </IconButton>
        ) : null}
        {userPermissions.canRead ? (
          <IconButton
            color='primary'
            onClick={(e) => handleGridBtnEditClick(e, item)}
          >
            <DetailIcon />
          </IconButton>
        ) : null}
      </Stack>
    );
  };
  const handleGridBtnEditClick = (event, item) => {
    event.stopPropagation();
    setIdToPerform(item.id);
    setShowAddModal(true);
  };
  const handleGridBtnDeleteClick = (event, item) => {
    event.stopPropagation();
    setIdToPerform(item.id);
    setShowDeleteModal(true);
  };
  //#endregion

  //#region Actions
  const handleBtnAddClick = async () => {
    setIdToPerform(0);
    setShowAddModal(true);
  };
  const handleCloseModalAdd = () => {
    setShowAddModal(false);
  };
  const handleModalAddItemAdded = () => {
    setIdToPerform(0);
    setShowAddModal(false);
    loadTabellaDatas(tabella);
  };
  //#endregion

  //#region Modal Delete
  const handleModalDeleteClose = () => {
    setIdToPerform(0);
    setShowDeleteModal(false);
  };
  const handleModalDeleteOkClick = async () => {
    try {
      setBackDropOpen(true);

      if (idToPerform > 0) {
        if (tabella === "base_mezzo_pagamento") {
          const tbResponse = await apiDeleteBaseMezzoPagamento.fetch({
            tenantId: tenantId,
            id: parseInt(idToPerform),
          });
          if (tbResponse.data.errors !== undefined) {
            enqueueSnackbar(t("error.generale"), { variant: "error" });
          } else {
            //Aggiungo la Audit per tracciare l'azione
            const itemById = JSON.stringify(
              tabellaItems.filter(
                (item) => item.id === parseInt(idToPerform)
              )[0]
            );
            apiAddAudit.fetch({
              tenantId: tenantId,
              aziendaId: aziendaId,
              area: bsaSettingsTabellaBase,
              operation: "Delete",
              entityType: "base_mezzo_pagamento",
              entityId: idToPerform.toString(),
              oldValues: itemById,
              newValues: "",
            });
            enqueueSnackbar(t("message.success"), { variant: "success" });
          }
        } else if (tabella === "base_origine_fondi") {
          const tbResponse = await apiDeleteBaseOrigineFondi.fetch({
            tenantId: tenantId,
            id: parseInt(idToPerform),
          });
          if (tbResponse.data.errors !== undefined) {
            enqueueSnackbar(t("error.generale"), { variant: "error" });
          } else {
            //Aggiungo la Audit per tracciare l'azione
            const itemById = JSON.stringify(
              tabellaItems.filter(
                (item) => item.id === parseInt(idToPerform)
              )[0]
            );
            apiAddAudit.fetch({
              tenantId: tenantId,
              aziendaId: aziendaId,
              area: bsaSettingsTabellaBase,
              operation: "Delete",
              entityType: "base_origine_fondi",
              entityId: idToPerform.toString(),
              oldValues: itemById,
              newValues: "",
            });
            enqueueSnackbar(t("message.success"), { variant: "success" });
          }
        } else if (tabella === "base_tipo_documento") {
          const anagraifcheTenantResponse = await apiAnagraficheByTenant.fetch({
            tenantId: tenantId,
            userId: loggedUserId,
          });
          
          var anagrafiche = anagraifcheTenantResponse.data.data.anagrafica;         
          var docTypeIdents = anagrafiche.map(anag=> anag.DocTipoId)
          if(docTypeIdents.includes(idToPerform)){
            enqueueSnackbar("Il tipo di documento è in uso, impossibile eliminarlo", {variant: "error"})
            return;
          }

          const tbResponse = await apiDeleteBaseTipoDocumento.fetch({
            tenantId: tenantId,
            id: parseInt(idToPerform),
          });
          if (tbResponse.data.errors !== undefined) {
            enqueueSnackbar(t("error.generale"), { variant: "error" });
          } else {
            //Aggiungo la Audit per tracciare l'azione
            const itemById = JSON.stringify(
              tabellaItems.filter(
                (item) => item.id === parseInt(idToPerform)
              )[0]
            );
            apiAddAudit.fetch({
              tenantId: tenantId,
              aziendaId: aziendaId,
              area: bsaSettingsTabellaBase,
              operation: "Delete",
              entityType: "base_tipo_documento",
              entityId: idToPerform.toString(),
              oldValues: itemById,
              newValues: "",
            });
            enqueueSnackbar(t("message.success"), { variant: "success" });
          }
        }
      }
    } catch (e) {
      if (e.message.includes("Foreign key violation.")) {
        enqueueSnackbar(
          "Non è possibile eliminare questo record perchè attualmente in uso.",
          { variant: "error" }
        );
      } else {
        enqueueSnackbar(t("error.generale"), { variant: "error" });
      }
      logApi.AddLog(e.message,e.stack,"handleModalDeleteOkClick", "TabellaBaseHome")     
    } finally {
      setIdToPerform(0);
      setShowDeleteModal(false);
      loadTabellaDatas(tabella);
      setBackDropOpen(false);
    }
  };
  //#endregion

  //#region Retrun Grapihcs
  return (
    <VaporPage
      title={t("nav.tabelleBase")}
      headerRight={
        userPermissions.canCreate ? (
          <Button
            variant='text'
            size='medium'
            endIcon={<AddIcon />}
            color='primary'
            onClick={handleBtnAddClick}
            disabled={
              isTenantEnabled && userPermissions.canCreate && tabella === ""
            }
            sx={{ mr: 2 }}
          >
            {t("actions.nuovo")}
          </Button>
        ) : null
      }
    >
      <Loading open={backDropOpen} />

      {isDataLoaded && !userPermissions.canRead ? <NotAuth /> : null}

      {showAddModal && tabella !== "" ? (
        <TabellaBaseForm
          show={showAddModal}
          tabella={tabella}
          nItems={tabellaItems.length}
          itemId={idToPerform}
          onClose={handleCloseModalAdd}
          onAdded={handleModalAddItemAdded}
          baseTipoDocumento={
            allBaseTipiDocumento.length > 0 ? allBaseTipiDocumento : null
          }
        />
      ) : null}

      {showDeleteModal && idToPerform > 0 ? (
        <ModalDelete
          show={showDeleteModal}
          onClose={handleModalDeleteClose}
          onOk={handleModalDeleteOkClick}
          deleteMessage={t("modal.deleteDesc")}
        ></ModalDelete>
      ) : null}

      {isDataLoaded && userPermissions.canRead ? (
        <VaporPage.Section>
          <Grid
            container
            visibility={!userPermissions.canRead ? "hidden" : "block"}
          >
            <Grid item xs={12}>
              <Stack
                direction='row'
                spacing={2}
                divider={<Divider orientation='vertical' flexItem />}
              >
                <Grid item xs={3}>
                  <FormControl size='small' fullWidth>
                    <InputLabel id='ddlTabellaLabel' size='small'>
                      {t("impostazioni.tabellaBase.titolo")}
                    </InputLabel>
                    <Select
                      id='ddlTabella'
                      labelId='ddlTabellaLabel'
                      value={tabella}
                      label={t("impostazioni.tabellaBase.titolo")}
                      onChange={handleDdlTabellaChange}
                    >
                      <MenuItem value=''>
                        {t("component.select.seleziona")}
                      </MenuItem>

                      {tabelleList !== null
                        ? tabelleList.map((item) => (
                            <MenuItem
                              id={item.id}
                              key={uuidv4()}
                              value={item.id}
                            >
                              {item.name}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={9} sx={{ width: "100%" }}>
                  {tabellaRows.length > 0 ? (
                    <DataGridPro
                      rows={tabellaRows}
                      columns={tabellaColumns}
                      slots={{ toolbar: GridToolbar }}
                      autoHeight={true}
                      pageSizeOptions={[25, 50, 100]}
                      localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                      }
                      pagination
                      disableRowSelectionOnClick
                      onRowClick={(item, e) =>
                        handleGridBtnEditClick(e, item.row)
                      }
                      initialState={{
                        columns: {
                          columnVisibilityModel: {
                            id: false,
                          },
                        },
                        pagination: {
                          paginationModel: {
                            pageSize: 25,
                          },
                        },
                      }}
                      slotProps={{
                        toolbar: {
                          printOptions: { disableToolbarButton: true },
                        },
                      }}
                    />
                  ) : (
                    <NoData />
                  )}
                </Grid>
              </Stack>
            </Grid>
          </Grid>
        </VaporPage.Section>
      ) : null}
    </VaporPage>
  );
  //#endregion
};
